import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  ButtonNewRecord,
  FlexRow,
  TableEditButtons,
  toastFailure,
  usePaginatedQueryV8,
} from 'motion-components';
import { Card } from 'react-bootstrap';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetCollectorsRegionsQuery } from './graphql';
import { buildWhereFromFilterValues, Filters } from './filters';
import { CollectorRegionsDataGrid } from './collectorregions-grid';
import { handleExport } from './export-columns';
import { useApolloClient } from '@apollo/client';
import { getRouteByName } from 'app/routes';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserLocationPermissions } from 'shared-pages/hooks';
import { observer } from 'mobx-react-lite';
import { isAfisCyprus } from 'shared-pages/common/constants';

/* ----------------------------------------------------------- */
/* ------------------------ Page ----------------------------- */
export const CollectorsRegionsGridPage = observer(
  ({
    collectorId,
    isGridInForm = false,
    injectFooterElement = null,
    onRefetchReady,
  }: {
    collectorId?: number;
    isGridInForm?: boolean;
    injectFooterElement?: React.ReactNode;
    onRefetchReady?: (refetchFn: () => void) => void;
  }) => {
    const { appStore } = useRootStore();
    const { handleGraphqlError } = useHandleError('CollectorsRegionsGridPage');

    const location = useLocation<any>();
    const history = useHistory();
    const [selected, setSelected] = useState<any>(null);
    const { t } = useTranslation();

    const { canView, canAddNew, canEdit, canDelete } = useUserLocationPermissions();

    const handleAddNew = () => {};
    /* ------------------- Query ------------------------------- */
    const initOrderBy = 'region.name ASC';
    const query = usePaginatedQueryV8(
      gqlGetCollectorsRegionsQuery,
      buildWhereFromFilterValues,
      location.state?.order ?? initOrderBy,
      appStore,
      true,
      { collectorId: collectorId },
      isGridInForm,
    );
    const {
      loading,
      data,
      dataCount,
      error,
      initPageIndex,
      filtersChanged,
      gridPageChanged,
      queryState,
      queryParams,
      setQueryParams,
      refetch,
    } = query;

    useEffect(() => {
      onRefetchReady?.(refetch);
    }, [onRefetchReady, refetch]);

    const client = useApolloClient();

    const canCreateNew = true;
    const handleCreateNew = useCallback(() => {
      history.push({
        pathname: generatePath(getRouteByName('CollectorRegion'), { id: -1 }),
        state: {
          pathname: location.pathname,
          ...location.state,
        },
      });
    }, [history, location.pathname, location.state]);

    const gridRef = useRef();

    if (error) {
      handleGraphqlError('query-get', error);
      return <h3 className="text-center">{error.message}</h3>;
    } else {
      return (
        <Card className="shadow">
          <Card.Body className="nopadding">
            {/* Φίλτρα */}
            {/* <Filters onChange={filtersChanged} initialValues={queryState?.filterValues ?? {}} /> */}
            {/* Grid */}
            <CollectorRegionsDataGrid
              collectorId={collectorId}
              ref={gridRef}
              loading={loading}
              data={data}
              refetch={refetch}
              dataCount={dataCount}
              initPageIndex={initPageIndex}
              onPageChange={gridPageChanged}
              handleExport={() => {
                handleExport(client, queryState, t);
              }}
              initOrderBy={queryParams?.order ?? initOrderBy}
              onOrderChange={(orderBy) => {
                const newQueryParams = { ...queryParams, order: orderBy };
                setQueryParams(newQueryParams);
                if (!isGridInForm) {
                  history.replace({
                    pathname: location.pathname,
                    state: {
                      ...location.state,
                      order: orderBy,
                    },
                  });
                }
              }}
              selected={selected}
              setSelected={setSelected}
              injectFooterElement={injectFooterElement}
            />
          </Card.Body>
        </Card>
      );
    }
  },
);
